import UtilityPageLayout from "../component/layout/UtilityPageLayout";
import styles from "../component/placeholder.module.scss";

export const MetersAccountsPage = () => {
	return (
		<UtilityPageLayout title="Meters & Accounts">
			<div className={styles.placeholderContainer}>
				<h2 className={styles.title}>Linked Meters & Accounts</h2>
				<p className={styles.description}>
					View and manage customer meters, linked accounts, meter readings,
					and connection status information.
				</p>
				<div className={styles.comingSoon}>Coming Soon</div>
			</div>
		</UtilityPageLayout>
	);
};
